<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container" @click.stop.prevent="isSearchShow = false">
      <asideCom :activityIndex="2"></asideCom>
      <div class="myVideo">
        <p class="title">{{ $t("people.视频管理") }}</p>
        <div class="navBox clearfix">
          <div class="nav">
            <span :class="{ active: contentIndex == 0 }" @click="changeIndex(0)"
              >{{ $t("global.全部") }}<i>{{ allCount || 0 }}</i></span
            >
            <span :class="{ active: contentIndex == 2 }" @click="changeIndex(2)"
              >{{ $t("people.已通过") }}<i>{{ countStatus2 || 0 }}</i></span
            >
            <span :class="{ active: contentIndex == 1 }" @click="changeIndex(1)"
              >{{ $t("global.审核中") }}<i>{{ countStatus1 || 0 }}</i></span
            >
            <span :class="{ active: contentIndex == 3 }" @click="changeIndex(3)"
              >{{ $t("people.未通过") }}<i>{{ countStatus3 || 0 }}</i></span
            >
          </div>
          <div
            class="search"
            :class="{ isFocus: isSearchShow }"
            @click.stop.prevent
          >
            <img src="https://image.manamana.net/1615974397000_hAuwXbGu" alt="" />
            <input
              @focus="inputFocus"
              :placeholder="$t('people.请输入视频名称搜索')"
              type="text"
              v-model="keyword"
            />
          </div>
        </div>
        <div class="listBox" v-if="list.length">
          <div class="titleBox clearfix">
            <span class="title1">{{ $t("people.视频") }}</span>
            <span class="title2">{{ $t("people.状态") }}</span>
            <span class="title3" @click="changeTime(1)"
              >{{ $t("people.创作时间")
              }}<img
                :src="
                  orderColumn == 1
                    ? 'https://image.manamana.net/1615974664000_MkiqNHEa'
                    : order == 1
                    ? 'https://image.manamana.net/1615974642000_snLGmSWK'
                    : 'https://image.manamana.net/1615974684000_TQKCBhcb'
                "
                alt=""
            /></span>
            <span class="title4" @click="changeTime(2)"
              >{{ $t("people.上传时间")
              }}<img
                :src="
                  orderColumn == 2
                    ? 'https://image.manamana.net/1615974664000_MkiqNHEa'
                    : order == 1
                    ? 'https://image.manamana.net/1615974642000_snLGmSWK'
                    : 'https://image.manamana.net/1615974684000_TQKCBhcb'
                "
                alt=""
            /></span>
            <span class="title5">{{ $t("people.操作") }}</span>
          </div>
          <div class="videoBox">
            <div class="videoI clearfix" v-for="(item, i) in list" :key="i">
              <div
                class="imgBox"
                @click="gotoVideo(item)"
                :class="{ HoverPointer1: item.status == 2 }"
              >
                <img :src="item.thumb | imageUrl('', '212', '120')" alt="" />
                <span>{{ item.duration | secondToDate }}</span>
              </div>
              <div class="titleIntro">
                <p
                  class="name"
                  :class="{ HoverPointer2: item.status == 2 }"
                  @click="gotoVideo(item)"
                >
                  {{ item.name }}
                </p>
                <p class="number">
                  <span
                    ><img
                      src="https://image.manamana.net/1615974779000_FYhVcMod"
                      alt=""
                    />{{ item.viewCount || 0 }}</span
                  ><span
                    ><img
                      src="https://image.manamana.net/1615974621000_RkleSUlE"
                      alt=""
                    />{{ item.collectionCount }}</span
                  ><span
                    ><img
                      src="https://image.manamana.net/1615974429000_UsPgXOTt"
                      alt=""
                    />{{ item.likeCount }}</span
                  >
                </p>
              </div>
              <div
                class="status"
                @mouseenter="puhHover = i"
                @mouseleave="puhHover = null"
              >
                <p class="status1" v-if="item.status == 1">
                  {{ $t("people.审核中") }}
                </p>
                <p class="status2" v-if="item.status == 3">
                  {{ $t("people.未通过") }}
                  <el-popover placement="right" trigger="hover">
                    <p>{{ item.reason }}</p>
                    <img
                      slot="reference"
                      src="https://image.manamana.net/1615974600000_gZzzoSHT"
                      alt=""
                    />
                  </el-popover>
                </p>
                <div class="status3" v-if="item.status == 2">
                  <p class="statusHover">
                    {{
                      item.isPub == 1 ? $t("people.不公开") : $t("people.公开")
                    }}<img
                      :src="
                        puhHover == i
                          ? 'https://image.manamana.net/1615974741000_GuUiTHyu'
                          : 'https://image.manamana.net/1615974714000_yqKvsfGs'
                      "
                      alt=""
                    />
                  </p>
                  <div class="pubBox" v-if="puhHover == i">
                    <p class="pubHover" @click="setIsPub(item, 1)">
                      <img
                        v-if="item.isPub == 0"
                        src="https://image.manamana.net/1615974758000_zAwDIsRg"
                        alt=""
                      />{{ $t("people.公开") }}
                    </p>
                    <p class="pubHover" @click="setIsPub(item, 2)">
                      <img
                        v-if="item.isPub == 1"
                        src="/static/peopleCenter/account_videos_status_tick@2x.png"
                        alt=""
                      />{{ $t("people.不公开") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="time1" v-if="item.creationYear">
                {{ item.creationYear
                }}<i v-if="item.creationMonth"
                  >-{{
                    item.creationMonth >= 10
                      ? item.creationMonth
                      : "0" + item.creationMonth
                  }}</i
                >
              </div>
              <div class="time1 fillIn" v-else @click="popupShow(item, 4)">
                {{ $t("people.去填写") }}
              </div>
              <div class="time2">{{ item.time }}</div>
              <div class="operation">
                <span class="operation1" @click="goToEdit(item)">{{
                  $t("people.编辑")
                }}</span>
                <span
                  class="operation2"
                  @mouseenter="hoverIndex = i"
                  @mouseleave="hoverIndex = null"
                >
                  {{ $t("people.更多") }}
                  <div class="hoverDIV" v-if="hoverIndex == i">
                    <p @click="popupShow(item, 1)">
                      <img
                        src="https://image.manamana.net/1615974579000_PYBzFRaL"
                        alt=""
                      />{{ $t("people.获取链接") }}
                    </p>
                    <p @click="gotoVideoComment">
                      <img
                        src="https://image.manamana.net/1615974504000_bnxUdundefinedhr"
                        alt=""
                      />{{ $t("people.评论管理") }}
                    </p>
                    <p @click="popupShow(item, 2)">
                      <img
                        src="https://image.manamana.net/1615974560000_nNCuLvph"
                        alt=""
                      />{{ $t("people.下载") }}
                    </p>
                    <p @click="popupShow(item, 3)">
                      <img
                        src="https://image.manamana.net/1615974540000_mMdRQcta"
                        alt=""
                      />{{ $t("people.删除") }}
                    </p>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <pagination
            :totalRecord="totalRecord"
            :pageSize="pageSize"
            :pageIndex="pageIndex"
            @OnCurrentChanged="changePage"
          />
        </div>
        <div class="noVideo" v-else>
          <img class="videoImg" src="/static/v2/peopleCenter/video_empty.png" alt="">
          <p class="noData">{{$t("people.还没有视频")}}</p>
          <router-link class="goUpload" to="/UpVideo">{{$t("people.去上传视频")}}</router-link>
        </div>
      </div>
    </div>
    <div class="createPop" v-if="popupDiv">
      <div class="popBox">
        <p class="popTitle">
          <span class="title1">{{ getText(popupIndex) }}</span
          ><img
            class="close"
            @click="closePop"
            src="/static/close_btn@2x.png"
            alt=""
          />
        </p>
        <div class="textBox" v-if="popupShow1">
          <p class="text">{{ $t("people.视频链接") }}</p>
          <div class="content">
            <input ref="copyContent1" type="text" v-model="linkText" /><span
              @click="copy(1)"
              >{{ $t("people.复制") }}</span
            >
          </div>
          <p class="text">{{ $t("people.嵌入代码") }}</p>
          <div class="content">
            <input ref="copyContent2" type="text" v-model="ifrmaText" /><span
              @click="copy(2)"
              >{{ $t("people.复制") }}</span
            >
          </div>
        </div>
        <div class="upLoadBox" v-if="popupShow2">
          <div class="upDataBox">
            <p class="indexBox" v-for="(item, i) in qiniuData" :key="i">
              <span class="dataName">{{ item.name }}</span
              ><span class="dataTion"
                >{{ item.width || $t("people.未知") }} x
                {{ item.height || $t("people.未知") }} /
                {{ getVideoSize(item.size) }}</span
              ><a
                class="dataUp"
                :href="item.url | videoUrl | download(title)"
                >{{ $t("people.下载") }}</a
              >
            </p>
          </div>
        </div>
        <div class="deteleBox" v-if="popupShow3">
          <p class="deteleTitle">{{ $t("people.是否永久删除该作品？") }}</p>
          <div class="buttomBox">
            <span class="yes" @click="deleteVideo">{{ $t("global.是") }}</span>
            <span class="no" @click="closePop">{{ $t("global.否") }}</span>
          </div>
        </div>
        <div class="creaTime" v-if="popupShow4">
          <p class="timeTitle">{{ $t("people.创作时间") }}</p>
          <div class="timeSet">
            <el-select
              v-model="creationYear"
              clearable
              :placeholder="$t('video.年份')"
            >
              <el-option
                v-for="item in optionsYear"
                :key="item.label"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="creationMonth"
              clearable
              :placeholder="$t('video.月份(选填)')"
            >
              <el-option
                v-for="item in optionsMonth"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="timeButtom">
            <span class="bank" @click="closePop">{{ $t("global.返回") }}</span>
            <span
              class="deter"
              :class="{ noOk: !creationYear }"
              @click="createdTime"
              >{{ $t("global.确定") }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import asideCom from "@/components/aside.vue";
import Pagination from "@/components/v2/Pagination";
export default {
  name: "manageVideo",
  metaInfo() {
    return {
      title: this.$t("global.管理视频") + " | MANA",
    };
  },
  data() {
    return {
      contentIndex: 0,
      pageIndex: 1,
      pageSize: 10,
      totalRecord: 0,
      orderColumn: 1,
      order: 1,
      keyword: "",
      list: [],
      pagerParam: {
        pageSize: 20,
        pageCount: 1,
        currentPage: 1,
        total: 1,
      },
      hoverIndex: null,
      puhHover: null,
      popupDiv: false,
      popupShow1: false,
      popupShow2: false,
      popupShow3: false,
      popupShow4: false,
      linkText: null,
      ifrmaText: null,
      popupIndex: null,
      qiniuData: [],
      title: null,
      item: null,
      optionsMonth: [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" },
        { value: "6", label: "6" },
        { value: "7", label: "7" },
        { value: "8", label: "8" },
        { value: "9", label: "9" },
        { value: "10", label: "10" },
        { value: "11", label: "11" },
        { value: "12", label: "12" },
      ],
      optionsYear: [],
      creationMonth: null,
      creationYear: null,
      videoId: null,
      videoIds: "",
      Year: null,
      searchList: [],
      isSearchShow: false,
      countList: [],
      allCount: null,
      countStatus1: null,
      countStatus2: null,
      countStatus3: null,
    };
  },
  components: {
    MainLayout,
    asideCom,
    Pagination,
  },
  created() {
    this.getVideoCount();
    var myDate = new Date();
    var tYear = myDate.getFullYear();
    this.Year = Number(tYear);
    this.optionsYear = [
      { label: "1", value: this.Year },
      { label: "2", value: this.Year - 1 },
      { label: "3", value: this.Year - 2 },
      { label: "4", value: this.Year - 3 },
      { label: "5", value: this.Year - 4 },
      { label: "6", value: this.Year - 5 },
      { label: "7", value: this.Year - 6 },
      { label: "8", value: this.Year - 7 },
      { label: "9", value: this.Year - 8 },
      { label: "10", value: this.Year - 9 },
      { label: "11", value: this.Year - 10 },
      { label: "12", value: this.Year - 11 },
      { label: "13", value: this.Year - 12 },
      { label: "14", value: this.Year - 13 },
      { label: "15", value: this.Year - 14 },
      { label: "16", value: this.Year - 15 },
      { label: "17", value: this.Year - 16 },
      { label: "18", value: this.Year - 17 },
      { label: "19", value: this.Year - 18 },
      { label: "20", value: this.Year - 19 },
    ];
    this.getVideoList();
  },
  methods: {
    getVideoSize(limit) {
      var size = "";
      if (limit < 0.1 * 1024) {
        //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }

      var sizestr = size + "";
      var len = sizestr.indexOf(".");
      var dec = sizestr.substr(len + 1, 2);
      if (dec == "00") {
        //当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
      }
      return sizestr;
    },
    getVideoCount() {
      this.$http.get("/api/u/video/count").then((res) => {
        if (res.code === "OK") {
          this.countList = res.data;
          for (let i = 0; i < this.countList.length; i++) {
            this.allCount += this.countList[i].count;
            if (this.countList[i].status == 1) {
              this.countStatus1 = this.countList[i].count;
            }
            if (this.countList[i].status == 2) {
              this.countStatus2 = this.countList[i].count;
            }
            if (this.countList[i].status == 3) {
              this.countStatus3 = this.countList[i].count;
            }
          }
        }
      });
    },
    gotoVideo(item) {
      if (item.status == 2) {
        //视频通过审核的
        let routeData = this.$router.resolve({
          path: "/video/detail?id=" + item.videoId,
        });
        window.open(routeData.href, "_blank");
      }
    },
    gotoVideoComment() {
      let routeData = this.$router.resolve({
        path: "/videoComment",
      });
      window.open(routeData.href, "_blank");
    },
    getAllVideo() {
      this.keyword = "";
      this.videoIds = "";
      this.getVideoList();
    },
    inputFocus() {
      this.isSearchShow = true;
    },
    createdTime() {
      if (!this.creationYear) {
        return;
      }
      let params = {
        id: this.videoId,
        year: this.creationYear,
        month: this.creationMonth,
      };
      this.$http
        .post("/api/u/video/setCreatedTime/" + this.videoId, params)
        .then((res) => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            this.closePop();
            this.getVideoList();
          }
        });
    },
    setIsPub(item, index) {
      if (item.isPub == 0 && index == 1) {
        return;
      }
      if (item.isPub == 1 && index == 2) {
        return;
      }
      if (index == 1 && item.isPub == 1) {
        this.$http.post("/api/u/video/pub/" + item.videoId).then((res) => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            this.getVideoList();
          }
        });
      }
      if (index == 2 && item.isPub == 0) {
        this.$http.post("/api/u/video/pub/" + item.videoId).then((res) => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            this.getVideoList();
          }
        });
      }
    },
    changePage(index) {
      this.pageIndex = index;
      this.getVideoList();
    },
    changeIndex(index) {
      this.pageIndex = 1;
      this.contentIndex = index;
      this.getVideoList();
    },
    changeTime(index) {
      if (index == 1) {
        this.order = this.orderColumn == 1 ? "1" : this.order == 1 ? "2" : "1";
        this.orderColumn = 2;
      }
      if (index == 2) {
        this.order = this.orderColumn == 2 ? "1" : this.order == 1 ? "2" : "1";
        this.orderColumn = 1;
      }
      this.getVideoList();
    },
    getVideoList() {
      this.$http
        .get("/api/u/video/list2", {
          params: {
            tab: this.contentIndex,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            orderColumn: this.orderColumn,
            order: this.order,
            keyword: this.keyword,
            videoId: this.videoIds,
          },
        })
        .then((response) => {
          let data = response.data;
          this.list = data.list;
          this.totalRecord = data.totalRecord;
        });
    },
    deleteVideo() {
      if (this.item.isEdit) {
        this.$http
          .post("/api/u/video/delete/" + this.item.videoId)
          .then((res) => {
            this.closePop();
            this.$message(res.message);
            this.getVideoCount();
            this.getVideoList();
          });
      } else {
        this.$message(
          this.$t("global.该视频处于大赛中") + "," + this.$t("global.不可删除")
        );
      }
    },
    goToEdit(item) {
      if (item.isEdit) {
        this.$router.push("/UpVideo?edit=true&videoId=" + item.videoId);
      } else {
        this.$message(
          this.$t("global.该视频处于大赛中") + "," + this.$t("global.不可编辑")
        );
      }
    },
    popupShow(item, index) {
      this.popupDiv = true;
      this.popupIndex = index;
      if (index == 1) {
        let origin = window.location.origin;
        this.linkText = origin + "/video/detail?id=" + item.videoId;
        this.ifrmaText = `<iframe src=\'${origin}/video/${item.videoId}\' frameborder='0' allowfullscreen='true' scrolling='no' style='max-width:100%;width:730px;height:410px;'></iframe>`;
        this.popupShow1 = true;
      }
      if (index == 2) {
        this.title = item.name;
        // this.qiniuData = JSON.parse(item.qiniuData).resource;
        this.getVideoInfo(item.videoId);
        this.popupShow2 = true;
      }
      if (index == 3) {
        this.item = item;
        this.popupShow3 = true;
      }
      if (index == 4) {
        this.videoId = item.videoId;
        this.popupShow4 = true;
      }
    },
    getVideoInfo(id) {
      this.$http.get("/api/u/video/downloadinfo/" + id).then((res) => {
        if (res.code === "OK") {
          this.qiniuData = res.data;
          this.popupShow2 = true;
        }
      });
    },
    closePop() {
      this.popupDiv = false;
      this.popupShow1 = false;
      this.popupShow2 = false;
      this.popupShow3 = false;
      this.popupShow4 = false;
    },
    copy(index) {
      if (index == 1) {
        this.$refs.copyContent1.select();
        document.execCommand("Copy");
        this.$message.success(this.$t("global.已复制"));
      }
      if (index == 2) {
        this.$refs.copyContent2.select();
        document.execCommand("Copy");
        this.$message.success(this.$t("global.已复制"));
      }
    },
    getText(index) {
      if (index == 1) {
        return this.$t("people.获取链接");
      }
      if (index == 2) {
        return this.$t("people.下载");
      }
      if (index == 3) {
        return this.$t("people.删除作品");
      }
      if (index == 4) {
        return this.$t("people.编辑创作时间");
      }
    },
  },
  watch: {
    keyword(val) {
      if (val) {
        this.keyword = val;
        this.getVideoList();
      } else {
        this.getVideoList();
      }
    },
  },
};
</script>
<style>
.el-popover {
  max-width: 250px !important;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;

  .myVideo {
    width: 825px;

    .title {
      height: 30px;
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 30px;
    }

    .navBox {
      border-bottom: 1px solid rgba(235, 235, 235, 1);
      margin: 14px 0 20px 0;

      .nav {
        float: left;

        span {
          display: inline-block;
          margin-right: 40px;
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          line-height: 38px;
          height: 38px;
          cursor: pointer;

          i {
            margin-left: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
          }
        }

        .active {
          border-bottom: 2px solid #000;
          font-size: 16px;
          font-weight: 600;
          color: #333333;

          i {
            color: #333333;
          }
        }
      }

      .search {
        float: right;
        width: 250px;
        height: 36px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        padding-left: 12px;
        position: relative;

        img {
          width: 16px;
          height: 16px;
        }

        input {
          width: 200px;
          height: 32px;
          line-height: 32px;
          border: none;
        }

        .searchList {
          width: 250px;
          position: absolute;
          box-sizing: border-box;
          background: #FFFFFF;
          box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
          border: 1px solid #EBEBEB;
          left: 0;
          top: 38px;
          cursor: pointer;
          z-index: 11;

          .all {
            padding-left: 20px;
            height: 54px;
            line-height: 54px;
            font-size: 14px;
            font-weight: 500;
            color: #3664ED;
            border-bottom: 1px solid rgba(235, 235, 235, 1);
          }

          .listsBox {
            .listName {
              height: 34px;
              line-height: 34px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              padding: 0 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              &:hover {
                background: #F5F5F5;
              }
            }
          }
        }
      }

      .isFocus {
        border: 1px solid #2026CC;
      }
    }

    .listBox {
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      width: 823px;

      .titleBox {
        line-height: 40px;
        height: 40px;
        background: #F5F5F5;

        span {
          float: left;
          font-size: 13px;
          font-weight: 400;
          color: #999999;
          text-align: center;

          img {
            width: 12px;
            height: 12px;
            margin-left: 3px;
          }
        }

        .title1 {
          width: 348px;
          text-align: left;
          padding-left: 52px;
        }

        .title2 {
          width: 90px;
        }

        .title3 {
          width: 100px;
          cursor: pointer;
        }

        .title4 {
          width: 110px;
          cursor: pointer;
        }

        .title5 {
          width: 123px;
        }
      }

      .videoBox {
        padding: 20px;

        .videoI {
          margin-bottom: 30px;

          .imgBox {
            float: left;
            width: 106px;
            margin-right: 12px;
            position: relative;

            img {
              width: 106px;
            }

            span {
              position: absolute;
              bottom: 0;
              right: 0;
              padding: 0 5px;
              height: 16px;
              line-height: 16px;
              background: rgba(10, 10, 10, 0.8);
              font-size: 12px;
              font-weight: 400;
              color: #FFFFFF;
            }
          }

          .HoverPointer1 {
            cursor: pointer;
          }

          .titleIntro {
            float: left;
            width: 248px;
            margin-right: 12px;

            .name {
              height: 40px;
              font-size: 13px;
              font-weight: 600;
              color: #0A0A0A;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
              margin-bottom: 4px;
            }

            .HoverPointer2 {
              cursor: pointer;
            }

            .number {
              span {
                margin-right: 12px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;

                img {
                  width: 16px;
                  height: 16px;
                  vertical-align: bottom;
                  margin-right: 2px;
                }
              }
            }
          }

          .status {
            float: left;
            width: 90px;
            text-align: center;
            height: 24px;
            line-height: 24px;
            padding: 18px 0;

            .status1 {
              color: #FFC400;
            }

            .status2 {
              color: #FE5630;

              img {
                width: 14px;
                height: 14px;
                margin: 0 0 2px 2px;
                cursor: pointer;
              }
            }

            .status3 {
              position: relative;

              .statusHover {
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                cursor: pointer;

                img {
                  width: 10px;
                  height: 10px;
                  margin-left: 4px;
                  margin-bottom: 2px;
                }

                &:hover {
                  background: #F5F5F5;
                  color: #333333;
                }
              }

              .pubBox {
                position: absolute;
                width: 82px;
                padding: 8px 0;
                background: #FFFFFF;
                box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
                border: 1px solid #EBEBEB;
                top: 30px;
                left: 4px;
                z-index: 111;

                .pubHover {
                  font-size: 13px;
                  font-weight: 400;
                  color: #666666;
                  height: 34px;
                  line-height: 34px;
                  // text-align: left;
                  cursor: pointer;

                  img {
                    width: 10px;
                    height: 10px;
                    margin-right: 4px;
                  }

                  &:hover {
                    color: #333333;
                    background: #F5F5F5;
                  }
                }
              }
            }
          }

          .time1 {
            float: left;
            width: 100px;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            margin-top: 22px;
          }

          .fillIn {
            color: #3664ED;
            cursor: pointer;
          }

          .time2 {
            float: left;
            width: 110px;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            margin-top: 22px;
          }

          .operation {
            float: left;
            width: 103px;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #3664ED;

            span {
              cursor: pointer;
              display: inline-block;
            }

            .operation1 {
              width: 48px;
              height: 60px;
              line-height: 60px;
            }

            .operation2 {
              position: relative;
              width: 50px;
              height: 60px;
              line-height: 60px;
              .hoverDIV {
                position: absolute;
                padding: 8px 0;
                right: 0px;
                transform: translateX(100%);
                top: -48px;
                background: #FFFFFF;
                box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
                border: 1px solid #EBEBEB;

                p {
                  height: 34px;
                  line-height: 34px;
                  font-size: 13px;
                  font-weight: 400;
                  color: #333333;
                  white-space: nowrap;
                  padding: 0 20px;
                  text-align: left;

                  img {
                    width: 20px;
                    height: 20px;
                    margin-right: 4px;
                  }

                  &:hover {
                    background: #F5F5F5;
                  }
                }
              }
            }
          }
        }
      }
    }
    .noVideo {
      padding-top: 100px;
      text-align: center;
      .videoImg {
        width: 80px;
        height: 80px;
      }
      .noData {
        height: 21px;
        font-size: 15px;
        font-weight: 400;
        color: #B8B8B8;
        line-height: 21px;
        margin: 30px 0 40px 0;
      }
      .goUpload {
        display: inline-block;
        padding: 0 30px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #2026CC;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}

.createPop {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .popBox {
    width: 445px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .popTitle {
      height: 60px;
      line-height: 60px;
      padding-left: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      border-bottom: 1px solid #E0E0E0;

      .close {
        position: absolute;
        right: 24px;
        top: 23px;
        width: 13px;
        height: 13px;
        cursor: pointer;
      }
    }

    .textBox {
      padding: 0 24px 60px;

      .text {
        margin: 20px 0 10px 0;
        height: 21px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 21px;
      }

      .content {
        width: 397px;
        height: 32px;
        border: 1px solid #E0E0E0;

        input {
          width: 318px;
          height: 30px;
          line-height: 30px;
          border: none;
          padding-left: 8px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }

        span {
          display: inline-block;
          width: 68px;
          height: 30px;
          line-height: 30px;
          background: #2026CC;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }

    .upLoadBox {
      padding: 28px 24px 20px;

      .upDataBox {
        .indexBox {
          height: 32px;
          line-height: 32px;
          margin-bottom: 20px;
          display: flex;

          .dataName {
            display: inline-block;
            width: 66px;
            font-size: 14px;
            font-weight: 600;
            color: #333333;
          }

          .dataTion {
            display: inline-block;
            width: 228px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            text-align: right;
            margin: 0 20px;
          }

          .dataUp {
            display: inline-block;
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            background: #2026CC;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
            cursor: pointer;
          }
        }
      }
    }

    .deteleBox {
      padding-bottom: 36px;

      .deteleTitle {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        padding: 27px 0 32px 0;
        text-align: center;
      }

      .buttomBox {
        text-align: center;

        .yes {
          display: inline-block;
          width: 136px;
          height: 40px;
          background: #2026CC;
          line-height: 40px;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          margin-right: 28px;
          cursor: pointer;
        }

        .no {
          display: inline-block;
          width: 136px;
          height: 38px;
          border: 1px solid #999999;
          line-height: 38px;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          cursor: pointer;
        }
      }
    }

    .creaTime {
      padding: 20px 20px 40px;

      .timeTitle {
        height: 24px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 24px;
      }

      .timeSet {
        margin: 12px 0 60px 0;
      }

      .timeButtom {
        text-align: center;

        .bank {
          display: inline-block;
          width: 90px;
          height: 28px;
          line-height: 28px;
          border: 1px solid #999999;
          font-size: 14px;
          font-weight: 600;
          color: #999;
          margin-right: 20px;
          cursor: pointer;
        }

        .deter {
          display: inline-block;
          width: 90px;
          height: 30px;
          line-height: 30px;
          background: #2026CC;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          cursor: pointer;
        }

        .noOk {
          background: #E0E0E0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/video/manageVideo.vue